import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  RouterModule,
  withComponentInputBinding,
} from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { MARKED_OPTIONS, provideMarkdown } from 'ngx-markdown';
import { routes } from './app.routes';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en';
import localeDE from '@angular/common/locales/de';
import { I18nService } from './shared/services/i18n.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

export const SUPPORTED_LANGUAGES = ['en', 'de'] as const;
export const DEFAULT_LANGUAGE = SUPPORTED_LANGUAGES[0];

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

registerLocaleData(localeEN);
registerLocaleData(localeDE);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(),
    provideMarkdown({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useValue: {
          gfm: true,
          breaks: true,
        },
      },
    }),
    importProvidersFrom(
      InlineSVGModule.forRoot(),
      TranslateModule.forRoot({
        defaultLanguage: DEFAULT_LANGUAGE,
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      RouterModule.forRoot(routes, {
        bindToComponentInputs: true,
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        scrollOffset: [0, 64],
      }),
    ),
    {
      provide: LOCALE_ID,
      useFactory: (i18nService: I18nService): SupportedLanguage => {
        return i18nService.getLanguage();
      },
      deps: [I18nService],
    },
  ],
};
